<template>
      <vue-perfect-scrollbar class="scroll-area">
        <vs-tabs :key="refreshKey">
    <vs-progress
      indeterminate
      color="primary"
      v-if="isLoading == true"
    ></vs-progress>

    <vs-tab
      label="Transporter Profile"
      icon="dashboard"
      @click="colorx = '#8B0000'"
    >
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full">
          <vs-input label="Name" v-model="tpInfo.name" class="w-full mt-4" />
          <vs-input label="Code" v-model="tpInfo.code" class="w-full mt-4" />
          <vs-input
            label="Person In Charge Name"
            v-model="tpInfo.picName"
            class="w-full mt-4"
          />
          <vs-input
            label="Person In Charge Number"
            v-model="tpInfo.picNumber"
            class="w-full mt-4"
          />
          <label class="vs-input--label">Cargo/Tonnage Options</label>
          <v-select
            :options="industries2"
            v-model="tpInfo.cargo"
            taggable
            multiple
            placeholder="Select"
          />

          <label class="vs-input--label">Industry/Type</label>
          <v-select
            :options="industries"
            v-model="tpInfo.industry"
            taggable
            multiple
            placeholder="Select"
          />

          <vs-textarea
            v-model="tpInfo.address"
            label="Address"
            class="mb-0 md:mt-10 mt-6"
            rows="3"
          />
        </div>

        <div class="vx-col md:w-1/2 w-full">
          <vs-input
            type="text"
            label="Portal Username"
            v-model="tpInfo.tsUsername"
            class="w-full mt-4"
          />
          <vs-input
            type="text"
            label="Portal Password."
            v-model="tpInfo.tsPassword"
            class="w-full mt-4"
          />
          <vs-textarea
            v-model="tpInfo.remarks"
            label="Remarks"
            class="mb-0 md:mt-10 mt-6"
            rows="3"
          />
          <br />
          <label for="myvueDropZone">Upload Docs</label>

          <vue-dropzone
            ref="myVueDropzone"
            id="dropzone"
            :options="dropzoneOptions"
            v-on:vdropzone-success="vehicleImagesUpload"
            v-on:vdropzone-removed-file="vehicleImagesRemove"
          ></vue-dropzone>
        </div>
      </div>
    </vs-tab>
    <vs-tab label="Assets" icon="event" @click="colorx = '#8B0000'">
      <vx-card style="min-height: 500px">
        <p>
          Take a moment to <b>Add Transporter Assets</b> for easier Trip
          Management later. <br /><vs-button
            color="primary"
            type="border"
            icon-pack="feather"
            icon="icon-layout"
            @click="addAlarm"
            >Add Asset</vs-button
          >
        </p>

        <table class="responsive">
          <tr>
            <th>No.</th>
            <th>Plate No.</th>
            <th>GPS Unit Id (*)</th>
            <th>Type</th>
            <th>Remarks</th>
            <th>Actions</th>
          </tr>

          <tr :key="indextr" v-for="(tr, indextr) in tpAssets">
            <td>
              <span>
                <b>{{ indextr + 1 }}.</b></span
              >
            </td>
            <td>
              <input
                type="text"
                v-model="tpAssets[indextr].plateNo"
                class="w-full mt-5"
              />
            </td>
            <td>
              <input
                type="text"
                v-model="tpAssets[indextr].unitId"
                class="w-full mt-5"
              />
            </td>
            <td>
              <v-select
                placeholder="Type"
                clearable="false"
                taggable
                :options="industries2"
                v-model="tpAssets[indextr].type"
              />
            </td>

            <td>
              <vs-textarea
                v-model="tpAssets[indextr].remark"
                class="w-full mt-5"
                rows="4"
              />
            </td>
            <td>
              <vs-button color="danger" @click="removeAlarm(indextr)"
                >Remove</vs-button
              >
              &nbsp;
            </td>
          </tr>
        </table>
      </vx-card>
    </vs-tab>
    <vs-tab
      label="Notification Channels"
      icon="event"
      @click="colorx = '#8B0000'"
    >
      <p>
        Setup <b>Notification Channels</b> to receive reminders in your
        preffered apps. Push Notifications are turned ON by DEFAULT.
      </p>
      <h5>How to Receive Telegram Notifications</h5>
      <ul>
        <li>
          1. Click to Send message to our
          <a href="https://t.me/Igeotechgps_bot" target="_blank"
            >Igeotechgps Telegram account</a
          >
        </li>
        <li>2. COPY & PASTE the Chat ID received in the details section.</li>
        <li>
          3. If need assistance text us as
          <a
            :href="
              'https://api.whatsapp.com/send?phone=' +
              userInfo.help_whatsapp +
              '&text=Hi%20Igeotechgps%20Support!'
            "
            target="_blank"
            >Igeotechgps Support</a
          >
        </li>
      </ul>

      <br />
      <vs-button
        color="primary"
        type="border"
        icon-pack="feather"
        icon="icon-phone"
        @click="addNotification"
        >Add New Channel</vs-button
      >
      <table class="responsive">
        <tr>
          <th>No.</th>
          <th>Type</th>
          <th>Detail</th>
          <th>Remarks</th>
          <th>Actions</th>
        </tr>
        <tr></tr>
        <tr :key="indextr" v-for="(tr, indextr) in tpNotifications">
          <td>
            <span>
              <b>{{ indextr + 1 }}.</b></span
            >
          </td>
          <td>
            <v-select
              placeholder="Type"
              clearable="false"
              :options="['Telegram', 'Email']"
              v-model="tpNotifications[indextr].type"
            />
          </td>
          <td>
            <vs-input
              v-validate="'required'"
              data-vv-validate-on="blur"
              v-model="tpNotifications[indextr].detail"
              icon-no-border
              icon="icon icon-user"
              icon-pack="feather"
              label-placeholder="Details"
              class="w-full"
            />
          </td>
          <td>
            <vs-input
              v-validate="'required'"
              data-vv-validate-on="blur"
              v-model="tpNotifications[indextr].remark"
              icon-no-border
              icon="icon icon-user"
              icon-pack="feather"
              label-placeholder="Remarks"
              class="w-full"
            />
          </td>
          <td>
            <vs-button color="danger" @click="removeNotification(indextr)"
              >Remove</vs-button
            >
            &nbsp;
          </td>
        </tr>
      </table>
    </vs-tab>
    <vs-tab label="API Endpoints" icon="event" @click="colorx = '#8B0000'">
      <vx-card style="min-height: 500px">
        <p>
          Take a moment to <b>Add API Integration Endpoints</b> for easier Trip
          Management later. <br /><vs-button
            color="primary"
            type="border"
            icon-pack="feather"
            icon="icon-layout"
            @click="addAlarm2"
            >Add API Endpoints</vs-button
          >
        </p>

        <table class="responsive">
          <tr>
            <th>No.</th>
            <th>Type</th>
            <th>Source IP</th>
            <th>Endpoint</th>
            <th>Parameters</th>
            <th>Remarks</th>
            <th>Actions</th>
          </tr>

          <tr :key="indextr" v-for="(tr, indextr) in tpEndpoints">
            <td>
              <span>
                <b>{{ indextr + 1 }}.</b></span
              >
            </td>
            <td>
              <v-select
                placeholder="Type"
                clearable="false"
                :options="[
                  'New Order',
                  'Order Acceptance',
                  'Order Cancellation',
                  'Order Modification',
                  'Trip Delay',
                  'Trip Deviation',
                  'Trip Completion',
                  'Trip Details',
                ]"
                v-model="tpEndpoints[indextr].type"
              />
            </td>
            <td>
              <input
                type="text"
                v-model="tpEndpoints[indextr].source"
                class="w-full mt-5"
              />
            </td>
            <td>
              <input
                type="text"
                v-model="tpEndpoints[indextr].endpoint"
                class="w-full mt-5"
              />
            </td>
            <td>
              <vs-textarea
                v-model="tpEndpoints[indextr].params"
                class="w-full mt-5"
                rows="4"
              />
            </td>
            <td>
              <vs-textarea
                v-model="tpEndpoints[indextr].remark"
                class="w-full mt-5"
                rows="4"
              />
            </td>
            <td>
              <vs-button color="danger" @click="removeAlarm2(indextr)"
                >Remove</vs-button
              >
              &nbsp;
            </td>
          </tr>
        </table>
      </vx-card>
    </vs-tab>
  </vs-tabs>
  <br><br>
      </vue-perfect-scrollbar>

</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard';
import { MultiSelectPlugin } from '@syncfusion/ej2-vue-dropdowns';
import { Query, Predicate } from '@syncfusion/ej2-data';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import vSelect from 'vue-select';
import { getBaseURL } from '@/config.js';

export default {
  components: {
    FormWizard,
    TabContent,
    MultiSelectPlugin,
    Query,
    Predicate,
    vueDropzone: vue2Dropzone,
    vSelect,
  },
  data() {
    return {
      quickSelect: null,
      fleetConfig: null,
      popupActive: false,
      refreshKey: 0,
      isLoading: true,
      transporterId: this.$route.params.transporterId,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      allowCustomValue: true,
      loadingWizard: false,
      errorMsg: null,
      driverAlarm: [],
      unitSelection: JSON.parse(localStorage.getItem('unitSelection')),
      selectedUnit: null,
      tpEndpoints: [],
      tpNotifications: [],
      industries2: [
        '1 Tonne',
        '2 Tonnes',
        '3 Tonnes',
        '5 Tonnes',
        '5 Tonnes (Box lorry)',
        '10 Tonnes (Loading Capability Of 8 Tonnes)',
        '15 Tonnes (Loading Capability Of 14 Tonnes)',
        '1 tonne',
        '3 / 5 tonne',
        '10 Tonne (Cargo Truck)',
        '10 Tonne Tipper / Crane - 1',
        '20 Tonne Tipper / Crane - 1',
        'Ready Mix',
        'Prime Movers - 1',
        'Prime Movers - 2',
      ],
      industries: [
        'Personal Usage',
        'Agriculture & Farm Product',
        'Construction',
        'Container Handling',
        'Container Haulage',
        'Courier',
        'Drilling Rig Machine',
        'Food Distribution',
        'General Cargo',
        'Manufacturing Raw Materials',
        'Milling Machine',
        'Palm Oil',
        'Pavers',
        'Petro Chemical Tankers',
        'Road Roller',
        'Skid Steer Roller',
        'Stacker',
        'Tractor',
        'Tractor Back Pusher',
        'Utility & Public Services',
      ],
      tpInfo: {
        assetId: -1,
        plate: null,
        type: '',
        subType: '',
        brand: '',
        model: '',
        industry: null,
        class: null,
        vehicleImages: [],
      },
      dropzoneOptions: {
        url: getBaseURL() + '/fleets/uploadFiles',
        thumbnailWidth: 150,
        maxFilesize: 10.0,
        maxFiles: 15,
        addRemoveLinks: true,
        //autoProcessQueue: false
      },
    };
  },
  computed: {},
  methods: {
    vehicleImagesUpload(files, response) {
      this.tpInfo.vehicleImages.push(response.path);
    },
    vehicleDocumentsUpload(files, response) {
      this.tpInfo.vehicleImages.push(response.path);
    },
    addRecord() {
      this.fleetMaintenance.push({
        type: '',
        subtype: '',
        date: '',
        documents: [],
        remark: 'Amount:- | PIC:- | Payment Status:- | Others:-',
      });
    },

    updateFleets() {
      const self = this;

      self.$http
        .patch(`fleetsSingle/${self.transporterId}`, {
          tpInfo: self.tpInfo,
          tpAssets: self.tpAssets,
          tpEndpoints: self.tpEndpoints,
        })
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            self.getTransporters();

            self.isLoading = false;
          } else if (response.data.error) {
          } else {
          }
        })
        .catch(function (error) {});
    },
    getTransporters() {
      const self = this;

      self.$http
        .get(`transportersSingle/${self.transporterId}`, {})
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            self.tpInfo = JSON.parse(response.data.transporterDetails.tpInfo);
            self.tpAssets = JSON.parse(
              response.data.transporterDetails.tpAssets,
            );
            self.tpEndpoints = JSON.parse(
              response.data.transporterDetails.tpEndpoints,
            );
            self.tpNotifications = JSON.parse(
              response.data.transporterDetails.tpNotifications,
            );
            self.refreshKey++;
            self.isLoading = false;
          } else if (response.data.error) {
          } else {
          }
        })
        .catch(function (error) {});
    },
  },
  created() {},
  watch: {},
  mounted() {
    this.getTransporters();
  },
};
</script>

<style lang="scss" scoped>
td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
</style>
